var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "dashboard-block" }, [
    _c(
      "div",
      { staticClass: "alert alert-info alert-icon" },
      [
        _c("i", { staticClass: "fa fa-info" }),
        _vm._v("\n\n    Please verify your email address.\n\n    "),
        _vm.$userIsClient
          ? [
              _vm._v(
                "\n      You can not submit a booking request until your account is verified.\n    "
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.resendingVerificationEmail
          ? _c("span", { staticClass: "fa fa-circle-o-notch fa-spin fa-fw" })
          : _c(
              "a",
              {
                attrs: { href: "" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.handleResendVerificationEmailCallback.apply(
                      null,
                      arguments
                    )
                  },
                },
              },
              [_vm._v("Resend Email.")]
            ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }